import {SensorsContainer} from './components/sensors-container';

export default {
    component: SensorsContainer
};
